import React, { useEffect, useRef, lazy, Suspense } from "react";
import Vimeo from "@vimeo/player";
import styled from "styled-components";
import { Typography } from "@mui/material";
import { NoContentWrapper } from "../../../pages/private/moduleBuilder/styles";

const PdfDocument = lazy(
  () => import("../../../pages/private/moduleBuilder/content/PdfDocument"),
);

const PdfHolder = styled.div`
  width: fit-content;
  height: 100%;
  text-align: center;
`;

const ContentWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  max-width: 1400px;
  min-height: 320px;
  gap: 16px;
  padding: 6px;
`;

const ContentBoxOne = styled.div`
  flex: 0.6;
  margin-bottom: 16px;
  margin-right: 16px;
`;

const QuestionText = styled(Typography)`
  color: darkgrey;
  font-size: 13px;
  font-weight: 400;
`;

const ContentBoxTwo = styled.div`
  flex: 0.4;
`;

const Content = ({ details }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (!details.video) return;
    if (!videoRef.current) return;

    const vimeoOptions = {
      url: `https://vimeo.com${details.video}`,
      width: 400,
      height: "auto",
    };
    const player = new Vimeo(videoRef.current, vimeoOptions);
    player.on("error", () => {});
  }, [details.video]);

  const hasNoContent = !details?.video && !details.media;

  return (
    <>
      <ContentWrapper>
        {hasNoContent && (
          <span style={{ padding: 0, color: "darkgrey", marginTop: 10 }}>
            No Content for this module yet.
          </span>
        )}
        {details.video && (
          <ContentBoxOne>
            <QuestionText sx={{ mb: 3 }}>Video</QuestionText>
            {!details.video && (
              <NoContentWrapper>
                <Typography variant="subtitle2">No Video Uploaded</Typography>
              </NoContentWrapper>
            )}
            <>
              <div ref={videoRef} id="video-player-review" />
            </>
          </ContentBoxOne>
        )}
        {details.media && (
          <ContentBoxTwo>
            <QuestionText sx={{ mb: 3 }}>PDF</QuestionText>
            {details.media === null ? (
              <NoContentWrapper>
                <Typography variant="subtitle2">No PDF Uploaded</Typography>
              </NoContentWrapper>
            ) : (
              <PdfHolder>
                <Suspense fallback={<span />}>
                  <PdfDocument media={{ content: details.media }} />
                </Suspense>
              </PdfHolder>
            )}
          </ContentBoxTwo>
        )}
      </ContentWrapper>
    </>
  );
};

export default Content;
